import React from 'react';
import classes from 'classnames';
import { useTranslate } from '../../features/languages';
import { EZLOGIC_TITLE_LOADING } from '../../constants/language_tokens';
import './style.scss';
import { SpinnerIcon } from '../../assets/icons';
import Navigation from '../Navigation';
import { hasNavigationBar } from '../Ezlo/pageLayout/hasNavigationBar';

const Preloader = () => {
    const { t } = useTranslate();
    const showNavigation = hasNavigationBar();

    return (
        <div className="preloader ezlo-page-wrapper">
            {showNavigation && <Navigation />}
            <div className={classes('content-wrapper', { full_width: !showNavigation })}>
                <div className="loader">
                    <SpinnerIcon height="200" width="200" className="loader__icon" />
                    <div className="loader__title">
                        <span className="animated-dots">{t(EZLOGIC_TITLE_LOADING)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Preloader;
